import { render, staticRenderFns } from "./ProfileMyProfileEditPasswordModal.vue?vue&type=template&id=34c0cb5c&scoped=true&"
import script from "./ProfileMyProfileEditPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileMyProfileEditPasswordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c0cb5c",
  null
  
)

export default component.exports